var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPiechart = function SvgPiechart(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m6.858 3.002 1.52 4.286a1 1 0 0 0 .496.56L12.94 9.88m-6.083-6.88a4.95 4.95 0 0 1 6.083 6.88m-6.083-6.88-.129-.362c-.185-.52-.762-.8-1.246-.535a6.334 6.334 0 1 0 8.18 9.252c.322-.449.116-1.056-.378-1.303l-.344-.172"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPiechart);
export default ForwardRef;